import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronUp = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M18 14L12 8L6 14'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M12 7.25C12.1989 7.25 12.3896 7.32908 12.5303 7.46973L18.5303 13.4697L18.582 13.5264C18.8223 13.8209 18.8049 14.2557 18.5303 14.5303C18.2557 14.8049 17.821 14.8223 17.5264 14.582L17.4697 14.5303L12 9.06055L6.53028 14.5303C6.23738 14.8232 5.76262 14.8232 5.46973 14.5303C5.17684 14.2374 5.17684 13.7626 5.46973 13.4697L11.4697 7.46973L11.584 7.37598C11.7063 7.29444 11.8509 7.25 12 7.25Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
